import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useRef } from 'react';
import Tooltip from '../tooltip';
import classNames from 'classnames';
var SliderTooltip = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _ref, _ref2;

  var visible = props.visible,
      prefixCls = props.prefixCls,
      reverse = props.reverse,
      vertical = props.vertical,
      min = props.min,
      max = props.max,
      bound = props.bound,
      others = __rest(props, ["visible", "prefixCls", "reverse", "vertical", "min", "max", "bound"]);

  var thisTooltipRef = useRef(null);
  var tooltipRef = ref || thisTooltipRef;
  var sliderHandleClass = classNames("".concat(prefixCls, "-handle"), _defineProperty({}, "".concat(prefixCls, "-reverse"), reverse));
  var range = max - min;
  var offset = "".concat(Math.abs(bound - min) / range * 100, "%");
  var handleStyle = vertical ? (_ref = {}, _defineProperty(_ref, reverse ? 'top' : 'bottom', offset), _defineProperty(_ref, reverse ? 'bottom' : 'top', 'auto'), _ref) : (_ref2 = {}, _defineProperty(_ref2, reverse ? 'right' : 'left', offset), _defineProperty(_ref2, reverse ? 'left' : 'right', 'auto'), _ref2);
  var placement = vertical ? 'right' : 'top';
  return /*#__PURE__*/React.createElement(Tooltip, _extends({
    ref: tooltipRef
  }, others, {
    tip: bound,
    visible: visible,
    placement: placement
  }), /*#__PURE__*/React.createElement("div", {
    className: sliderHandleClass,
    style: handleStyle
  }));
});
export default SliderTooltip;